import Model from "./Model";

export default class Resource extends Model {
    constructor(data) {
        super(data);
    }
}
